import { render, staticRenderFns } from "./FormGraphics.vue?vue&type=template&id=82b04858&"
import script from "./FormGraphics.vue?vue&type=script&lang=js&"
export * from "./FormGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports